export const useSxStyles = () => {
  return {
    loadingMiddle: {
      position: 'absolute',
      left: '50%',
      right: '50%',
      top: '50%',
      bottom: '50%',
    },
  };
};
